<template>
  <main v-bind:class="[{'fullscr instructions': instructions}, {'game': !instructions}]" v-if="auth">
      <!-- <AppIpadBackground v-if="customise" /> -->
      <AppSiteHeader />
    <div class="container">
      <div class="info_container" v-if="!instructions">
          <div class="mobile_trigger" v-bind:class="{hide_mobi_trigger: $store.getters.item_correct === 'true' && !$store.getters.message || $store.getters.item_correct === 'false' && !$store.getters.message}" v-if="!customise"><div class="trigger_arrow"></div></div>
          <AppCase :sub="$t('game.'+level+'.sub')" :title="$t('game.'+level+'.title')" :description="$t('game.'+level+'.description')"  v-if="this.$route.name === 'game'"/>
      </div>
      <div :class="{'page': instructions}">
       <AppGameInstructions v-if="instructions" :beforeRouteEnter="this.prevRoute? this.prevRoute : {}" :information="info" :did_you_know="icon" :dyktitle="dyk_title" :dykdescription="dyk_description"/>
      <div class="character_container" v-bind:class="{'no_bg': customise, 'logistics-bg': (level === 'logistics'), 'lab-bg': (level === 'lab'), 'construction-bg': (level === 'construction')}">
          <AppCharacter />
          <AppGameControl :level="level" />
      </div>
      </div>
      <div class="selection_container" v-bind:class="{no_items: customise}" v-if="!instructions">
        <div class="overlay" v-if="customise" />
          <AppItemsSelector v-draggable v-bind:scenarios="get_items" />
        </div>
      <AppMobilePicker v-bind:scenarios="get_items" v-if="$route.name === 'game'"/>
    </div>
  </div>
</main>
</template>
<script>
  import AppCase from '@/components/AppCase.vue'
  import AppGameInstructions from '@/components/AppGameInstructions.vue'
  import AppIpadBackground from '@/components/AppIpadBackground'
  import AppCharacter from '@/components/AppCharacter.vue'
  import AppSiteHeader from '@/components/AppSiteHeader.vue'
  import AppGameControl from '@/components/AppGameControl.vue'
  import AppMobilePicker from '@/components/AppMobilePicker.vue'
  import AppItemsSelector from '@/components/AppItemsSelector.vue'
  import appStyles from '@/styles/appStyles.scss'

  export default {
    name: 'game',
    props: ['level'],
    components: {
      AppCase,
      appStyles,
      AppGameInstructions,
      AppCharacter,
      AppSiteHeader,
      AppGameControl,
      AppMobilePicker,
      AppItemsSelector,
      AppIpadBackground
    },
    data() {
      return {
        auth: false,
        instructions: '',
        customise: '',
        path: null,
        info: false,
        prevRoute: null,
        icon: false,
        dyk_title: '',
        dyk_description: '',
        get_items: ''
      }
    },
    methods: {
      checkUser: function() {
        const timeout = 1200000; // timeout in miliseconds
          this.$session.get('logged_in')? this.auth = true : (this.$router.push({ path: `/register` }));
          var duration = (new Date().getTime()) - (parseInt(this.$session.get('timeout')*1000));
          // duration > timeout ? this.$session.clear() : this.$session.set('timeout', new Date().getTime()/1000);
          // duration > timeout ? this.$router.push({ path: `/register` }) : this.$session.set('timeout', new Date().getTime()/1000);  
          // console.log(duration);
          // console.log(timeout);
          // console.log(duration > timeout);
      },
      hidePulse: function() {
        document.querySelector('#target_torso').style.display = 'none';
        document.querySelector('#target_head').style.display = 'none';
        document.querySelector('#target_hand').style.display = 'none';
        document.querySelector('#target_feet').style.display = 'none';
      },
      setDykInfo: function(level){
            this.ready_description = this.$t('game.'+level+'.description');
            this.dyk_title = this.$t('game.'+level+'.did_you_know_title');
            this.dyk_description = this.$t('game.'+level+'.did_you_know_description');
      },
      removeDykInfo: function(){
            this.ready_description = '';
            this.dyk_title = '';
            this.dyk_description = '';
      },
      shuffle: function(a){
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return this.get_items = a;
      },
      hideOverflow() {
        var el = document.querySelector('main');
        el.style.overflow = 'hidden';
      }
    },
    beforeMount() {
      // console.log(this.$session.getAll());
      this.checkUser();
      // console.log(this.$route.name);
      this.$route.name === 'game'? this.customise = false : null;
      this.$route.name === 'customise'? (document.body.classList.add('overhidden')) : null;
      this.$route.name === 'game'? (document.body.classList.add('overhidden')) : null;
      this.$route.name === 'instructions'? this.instructions = true : this.instructions = false;
      this.$route.name === 'customise'? (this.customise = true) && (this.instructions = false) : (this.customise = false);
      this.$route.name === 'ready' ? (this.instructions = true) && (this.customise = false) : null;
      this.$route.name === 'complete' ? (this.instructions = true) && (this.customise = false) : null;
      this.$route.params.icon === 'i' ? this.icon = true : null;
      this.removeDykInfo();
      this.$route.name === 'game' ? this.setDykInfo(this.$route.params.level) : null;
      this.$route.name === 'instructions' ? this.setDykInfo(this.prevRoute.params.level) : null;
      // this.$route.name === 'game' ? this.hidePulse() : null;
      this.shuffle(this.$t('game.'+this.level+'.items'));
    },
    mounted() {
      // this.hidePulse();
      this.$route.name === 'customise' ? this.hideOverflow() : null;
      // this.$route.name === 'game' ? this.hideOverflow() : null;
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
    watch: {
      $route(to, from) {
        // console.log(to);
        // console.log(from);
        to.name === 'game' ? (this.customise = false) : null;
        to.name === 'game' ? (this.instructions = false) : null;
        to.name === 'instructions' ? this.instructions = true : null;
        to.name === 'customise' ? (this.customise = true) && (this.instructions = false) : null;
        to.name === 'customise' ? (document.body.classList.add('overhidden')) : null;
        to.name === 'game' ? (document.body.classList.add('overhidden')) : null;
        to.name === 'ready' ? (this.instructions = true) && (this.customise = false) : null;
        to.name === 'complete' ? (this.instructions = true) && (this.customise = false) : null;
        // to.name === 'game'? this.hidePulse() : null;
        from.name === 'game' ? this.info = true : null;
        from.name === 'game' ? this.path = from.name : null;
        to.params.icon === 'i' ? this.icon = true : null;
        to.name === 'game' ? (this.icon = false) : null;
        to.name === 'game' ? this.removeDykInfo() : null;
        to.name === 'game' ? this.setDykInfo(to.params.level) : null;
        to.name === 'instruction' ? this.setDykInfo(this.prevRoute.params.level) : null;
        this.shuffle(this.$t('game.'+this.level+'.items'));
      }
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .overhidden {
    /* overflow: hidden; */
  }
  .hide_mobi_trigger {
    display: none;
  }
  .overlay {
    background-color: #fffffffa;
  }
  .no_bg {
    background: none;
  }
  .no_items {
    display: none;
  }
  .lab-bg {
    background-image: linear-gradient(to right, rgba(248, 251, 255, 0.8) 0%,rgba(255,255,255,0) 45%,rgba(255,255,255,0) 55%,rgba(248, 251, 255, 0.8) 100%), url('../../public/assets/LAB.jpg');
  }
  .logistics-bg {
    background-image: linear-gradient(to right, rgba(248, 251, 255, 0.8) 0%,rgba(255,255,255,0) 45%,rgba(255,255,255,0) 55%,rgba(248, 251, 255, 0.8) 100%), url('../../public/assets/ware_house.jpg');
  }
  .construction-bg {
    background-image: linear-gradient(to right, rgba(248, 251, 255, 0.8) 0%,rgba(255,255,255,0) 45%,rgba(255,255,255,0) 55%,rgba(248, 251, 255, 0.8) 100%), url('../../public/assets/bui_ico.jpg');
  }
</style>